import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, MapPin, CheckCircle2, Circle, Clock } from "lucide-react";
import { fmtD } from "../lib/date";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function PermitStatusView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${BACKEND}/api/public/permit-status/${token}`).then((r) => setData(r.data)).catch(() => setErr("进度链接无效或已失效")); }, [token]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="permit-status-error">{err}</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-amber-500" /></div>;

  return (
    <div className="min-h-screen bg-slate-100" data-testid="permit-status-page">
      <div className="bg-slate-900 text-white px-5 py-4 flex items-center gap-2">
        <span className="font-bold text-red-500 text-lg">ALIGCUS</span>
        <div><p className="text-sm font-semibold">阿里建筑 · Permit 办理进度</p><p className="text-[11px] text-slate-300">ALIGCUS · Permit Progress</p></div>
      </div>
      <div className="max-w-[620px] mx-auto p-4 space-y-4">
        <div className="bg-white rounded-2xl p-5 shadow-sm">
          <p className="text-[11px] text-slate-400">项目地址 PROJECT ADDRESS</p>
          <p className="text-lg font-bold text-slate-800 flex items-center gap-1.5"><MapPin className="h-4 w-4 text-amber-500" />{data.address || data.clientName}</p>
          <p className="text-sm text-slate-500 mt-1">{data.clientName}{data.projectNo ? ` · ${data.projectNo}` : ""}</p>
        </div>

        <div className="bg-white rounded-2xl p-5 shadow-sm" data-testid="permit-status-timeline">
          {!data.started && <p className="text-sm text-amber-600 mb-3" data-testid="permit-status-not-started">您的 Permit 办理即将启动，我们收到 Ready-for-Permit 图纸后会立即提交受理。</p>}
          {data.estApprovalDate && (
            <div className={`mb-4 rounded-xl px-4 py-3 ${data.estApprovalIsActual ? "bg-emerald-50" : "bg-amber-50"}`} data-testid="permit-est-approval">
              <p className={`text-[11px] ${data.estApprovalIsActual ? "text-emerald-600" : "text-amber-600"}`}>{data.estApprovalIsActual ? "实际批准日期 APPROVED ON" : "预计批准日期 EST. APPROVAL"}</p>
              <p className={`text-lg font-bold ${data.estApprovalIsActual ? "text-emerald-700" : "text-amber-700"}`}>{fmtD(data.estApprovalDate)}</p>
              {!data.estApprovalIsActual && <p className="text-[11px] text-slate-500 mt-0.5">基于 {data.city || "当地"} 市政平均审查周期约 {data.reviewDays} 天估算，实际以市政审批为准。</p>}
            </div>
          )}
          <ol className="relative">
            {data.steps.map((s, i) => {
              const Icon = s.done ? CheckCircle2 : s.active ? Clock : Circle;
              const color = s.done ? "text-emerald-500" : s.active ? "text-amber-500" : "text-slate-300";
              const last = i === data.steps.length - 1;
              return (
                <li key={s.key} className="flex gap-3 pb-6 last:pb-0" data-testid={`permit-step-${s.key}`}>
                  <div className="flex flex-col items-center">
                    <Icon className={`h-6 w-6 ${color}`} />
                    {!last && <div className={`w-0.5 flex-1 mt-1 ${s.done ? "bg-emerald-300" : "bg-slate-200"}`} style={{ minHeight: 24 }} />}
                  </div>
                  <div className="pt-0.5">
                    <p className={`text-sm font-semibold ${s.active ? "text-amber-600" : s.done ? "text-slate-800" : "text-slate-400"}`}>{zhStep(s)}</p>
                    {s.active && <p className="text-[11px] text-amber-500 mt-0.5">进行中 In progress</p>}
                    {s.done && <p className="text-[11px] text-emerald-500 mt-0.5">已完成 Done{s.date ? ` · ${fmtD(s.date)}` : ""}</p>}
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
        <p className="text-center text-[11px] text-slate-400 pb-6">进度实时更新，如有疑问欢迎联系您的项目顾问。<br />阿里建筑 ALIGCUS · 626-803-8000 / 408-900-6688</p>
      </div>
    </div>
  );
}

function zhStep(s) { return s.zh || s.en || s.key; }
